<template>
<div id="setnewpassword">
	<linepreloader v-if="loading"/>
	<div v-if="(hash) && !loading">
		<div class="caption mobp">
			<span>{{ $t("common.2901029") }}</span>
		</div>

		<div class="item mobp">
			<div class="label">
				<label for="password">{{ $t("common.2901030") }}</label>
			</div>
			<div class="input">
				<input type="password" :value="password" @input="changePassword" name="password" autocomplete="off" :placeholder="$t('common.2901031')"/>
			</div>
		</div>

		<div class="item mobp">
			<div class="label">
				<label for="cpassword">{{ $t("common.2901032") }}</label>
			</div>
			<div class="input">
				<input type="password" @input="confirmpassword = $event.target.value" :value="confirmpassword" autocomplete="off" name="cpassword" :placeholder="$t('labels.confirmyourpassword')" />
			</div>
		</div>

		<div class="savePanel mobp">
			<button class="button" @click="send" :disabled="!valid">
				{{ $t("next") }}
			</button>
		</div>
	</div>

	<div class="mobp error" v-if="(!hash) && !loading">
		<div>
			<span>{{ $t("common.nohashforpwd") }}</span>
		</div>
	</div>

</div>
</template>

<style scoped lang="sass">
#setnewpassword
	padding : 0 $r

.caption
	max-width: 70%
	margin-bottom: 4 * $r

	span
		font-size: 2em
		font-weight: 100
.item
	margin-top : 2 * $r
	.label
		color : srgb(--color-bg-ac-bright)
		margin-bottom: $r

.error
	span
		font-size: 2em
input
	background: srgb(--background-secondary-theme)
	padding : 0 3 * $r
	height: 66px
	background: srgb(--neutral-grad-0)
	width : 100%
	border-radius: 12px

::v-deep
	.Password__field
		border-radius: 12px
		padding : 0 3 * $r
		height: 66px
		background: srgb(--neutral-grad-0)
		width : 100%
		border : 0
		
	.Password__strength-meter
		border-radius: 12px

	.Password__badge
		border-radius: 50px
		height: 30px
		line-height: 30px
		font-size: 0.9em

</style>

<script>
import {
	mapState
} from "vuex";

export default {
	name: "setnewpassword",
	props: {
		data: Object,
	},
	components: {
	},
	data: function () {
		return {
			password: "",
			confirmpassword: "",
			hash: '',
			loading: false,
		};
	},
	computed: mapState({
		auth: (state) => state.auth,
		valid: function () {
			return this.password && this.password == this.confirmpassword;
		},
	}),

	mounted: function () {
		this.load();
	},

	methods: {
		changePassword: function (e) {
			this.password = e.target.value;
			
		},
		load: function () {
			this.hash = this.$route.query.hash;

		},

		send: function () {

			if (this.hash){

				this.core.api.user.restorePasswordContinue({
					pwdhash : this.core.user.crypt(this.password),
					hash : this.hash,
				}, {
					preloader : true,
					showStatus : true
				}).then(r => {
					this.$router.push('/').catch(e => {}).catch(e => {})
				})

			}	


			

		},
	},
};
</script>
